module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/software-v2-e719afae2dd531fa50446949fc6e5e2c.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/software-v2.svg
// module id = pPun
// module chunks = 1 3 10 12 18